import { getCustomSdk } from '@/sdk';

/**
 * Composable to access the custom SDK
 * Provides a centralized way to get the SDK instance
 */
export function useSdk() {
    return getCustomSdk();
}
